import {slideToggle} from './module/slide';
import gnavToggle from './module/gnavToggle';
import smoothScroll from './module/smoothScroll';
import bookmarkToggle from './module/bookmarkToggle';

(function () {
	const headerEl = document.getElementById('js-header');
	let timeoutId;

  window.addEventListener('DOMContentLoaded', function(e) {
    slideToggle();
	bookmarkToggle();
    smoothScroll();

	//レシピアーカイブへのリンク先を季節ごとで変更
	const archivesLinks = document.querySelectorAll('.js-link-archives');
	archivesLinks.forEach((link) => {
		const currentMonth = new Date().getMonth() + 1; // 1月は0、12月は11
		let season = '';
		if (currentMonth >= 3 && currentMonth <= 5) {
			season = 'spring';
		} else if (currentMonth >= 6 && currentMonth <= 8) {
			season = 'summer';
		} else if (currentMonth >= 9 && currentMonth <= 11) {
			season = 'autumn';
		} else {
			season = 'winter';
		}
		link.href = `https://www.kubara.jp/recipe/collection/${season}`;
	});
  });

	//スクロール中だけヘッダを表示
	window.addEventListener('scroll', (e) => {
		if(headerEl) {
			console.log("scroll");
			headerEl.classList.add('is-scrolling');
			clearTimeout( timeoutId ) ;
			timeoutId = setTimeout( function () {
				headerEl.classList.remove('is-scrolling');
			}, 500 ) ;
		}
	});

  gnavToggle();
})();
